import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { BaseService } from 'src/app/services/base.services';
import { LodgeClaimModel } from '../views/lodge-claim/state';

@Injectable()
export class LodgeClaimService extends BaseService {

  constructor(private http: HttpClient,
    public toastr: ToastrService) {
    super(toastr);
  }

  submit(accountId: number, obj: LodgeClaimModel): Observable<any> {
    return this.http.post<LodgeClaimModel>(environment.apiUrl + `/member-portal/BenefitPaymentClaim/${accountId}/submit`, obj, { headers: this.headers() });
  }

  getEmployers(accountId: number): Observable<any> {
    return this.http.get(environment.apiUrl + `/member-portal/BenefitPaymentClaim/${accountId}/employers`, { headers: this.headers() });
  }

  checkForMemberTfn(accountId: number): Observable<any> {
    return this.http.get(environment.apiUrl + `/member-portal/BenefitPaymentClaim/${accountId}/hastfn`, { headers: this.headers() });
  }
}
